/* Contains functions for determining the type and building
the right type of SysEx object from raw MIDI data */

import {SysexManufacturers} from "./sysexmanufacturers.js";
import {Sysex} from "./sysex.js";
import {SDSSysex} from "./sds/sdssysex.js";
import {DX7ParameterChange,DX7Voice,DX7Bank} from "./yamaha/dx7.js";
import {RolandSysex} from "./roland/roland.js";

// Obsolete

export class SysexFactory {

  /** Parses and returns the most specific type of SysEx
  * for the specified data. May be SysEx or a more specific class.
  * @param {Uint8Array} data
  * @param {string} filename
  * @returns {Sysex}
  * @throws Error if data does not contain a valid sysex
  */
  static parse(data)
  {
    //Sysex.sanityCheck(data);
    let sysex = undefined;

    let manufacturerId = SysexManufacturers.getId(data);
    let manufacturerName = SysexManufacturers.getName(manufacturerId);

    // Try to parse known sysex types...
    switch (manufacturerName) {
      case 'MIDI':
        if (SDSSysex.test(data)) {
          sysex = new SDSSysex(data);
        }
        break;

      case 'Roland':
        sysex = new RolandSysex(data);
        break;

      case 'Yamaha':
        if (DX7Voice.test(data)) {
          sysex = new DX7Voice(data);
        }
        if (DX7Bank.test(data)) {
          sysex = new DX7Bank(data);
        }
        if (DX7ParameterChange.test(data)) {
          sysex = new DX7ParameterChange(data);
        }
        break;
    }

    if (sysex === undefined) {
      sysex = new Sysex(data);
    }

    return sysex;
  }
}



// WEBPACK FOOTER //
// ./src/sysexfactory.js